// @returns { Promise } Resolves to whether the copy action happened or not.
export function copyTextToClipboard(text) {

    if (!navigator.clipboard) {
        console.warn('Clipboard API is not supported in this browser.')
        return false;
    }

    const handleSuccess = ()=> {
        console.log('Async: Copying to clipboard was successful!');
        return true;
    }

    const handleFail = ()=> {
        console.error('Async: Could not copy text: ', err);
        return false;
    }

    return navigator.clipboard.writeText(text).then(handleSuccess, handleFail);
}